export const isMobile = ({ $vuetify }): boolean =>
  $vuetify ? $vuetify.breakpoint.smAndDown : false;

export const isSmallMobile = ({ $vuetify }): boolean =>
  $vuetify ? $vuetify.breakpoint.xsOnly : false;

export const isTablet = ({ $vuetify }): boolean =>
  $vuetify ? $vuetify.breakpoint.mdAndDown : false;

export default { isMobile, isTablet };
